import qs from 'qs'
import axios from 'axios'
import { EVENT } from '@/constants/event'

export default {
  methods: {
    request (method, url, params, callback, errorCallback) {
      this.$emit(EVENT.SHOW_LOADING, true)
      if (method.toUpperCase() === 'GET' && params) {
        url += '?'
        for (let key in params) {
          url += `${key}=${params[key]}&`
        }
        url = url.slice(0, -1)
      }
      axios({
        method: method,
        url: url,
        data: qs.stringify(params)
      })
        .then((response) => {
          this.$emit(EVENT.SHOW_LOADING, false)
          if ('error' in response.data) {
            errorCallback
              ? errorCallback(response.data['error'])
              : this.$emit(EVENT.SHOW_WARNING, this.$t(`error__${response.data['error']}`))
          } else {
            if (method === 'post') {
              response.data['result'] === 0
                ? callback() : this.$emit(EVENT.SHOW_WARNING, this.$t('error__error_occured'))
            } else if (method === 'get') {
              callback(response.data)
            } else {
              this.$emit(EVENT.SHOW_WARNING, 'error_method')
            }
          }
        }, (error) => {
          this.$emit(EVENT.SHOW_LOADING, false)
          console.error(error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/bind/mixins/RequestMixin.js